import api from "../api.js";

export const fetchNotifications = async () => {
  const { data } = await api.get(`/notification`);
  return data; // { data, unreadCount }
};

export const markNotificationRead = async (id) => {
  const { data } = await api.put(`/notification/${id}/read`);
  return data;
};

export const markAllNotificationsRead = async () => {
  const { data } = await api.put(`/notification/read-all`);
  return data;
};